import { ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { toSignal } from '@angular/core/rxjs-interop';
import { PopupBaseComponent } from '../../../../shared/components/popup/popup-base/popup-base.component';
import { ButtonComponent, ButtonType } from '../../../../shared/components/button/button.component';
import { DeleteOrganizationPopupModel } from './delete-organization-popup.model';
import { LayoutStore, LayoutStoreType } from '../../../../core/store/layout.store';

@Component({
    selector: 'juyo-delete-organization-popup',
    styleUrl: './delete-organization-popup.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [PopupBaseComponent, ButtonComponent, ReactiveFormsModule],
    template: `
        <juyo-popup-base [popupId]="model().id" [showHeader]="true">
            <span slot="header">Delete Organization</span>

            <div slot="body" class="body">
                <p class="description">
                    This will permanently remove all properties, users, and data. This action cannot be undone.
                </p>
                <div class="field-group">
                    <label class="field-label" for="deleteConfirm">TYPE "DELETE" TO CONFIRM</label>
                    <input
                        type="text"
                        id="deleteConfirm"
                        class="field"
                        placeholder="DELETE"
                        [formControl]="confirmInput"
                    />
                </div>
            </div>

            <ng-container slot="footer">
                <juyo-button [buttonType]="ButtonType.TRANSPARENT" (clicked)="onCancel()">Cancel</juyo-button>
                <juyo-button [buttonType]="ButtonType.RED" [disabled]="!canDelete()" (clicked)="onConfirm()">
                    Delete Organization
                </juyo-button>
            </ng-container>
        </juyo-popup-base>
    `,
})
export class DeleteOrganizationPopupComponent {
    public model = input.required<DeleteOrganizationPopupModel>();

    protected readonly ButtonType = ButtonType;
    protected confirmInput = new FormControl<string>('', { nonNullable: true });

    private confirmValue = toSignal(this.confirmInput.valueChanges, { initialValue: '' });
    protected canDelete = computed(() => this.confirmValue() === 'DELETE');

    private layoutStore: LayoutStoreType = inject(LayoutStore);

    protected onConfirm(): void {
        this.model().onConfirm();
        this.layoutStore.closePopup(this.model().id);
    }

    protected onCancel(): void {
        this.layoutStore.closePopup(this.model().id);
    }
}
